module.exports = __webpack_public_path__ + "static/pic03-01d690e22a7a19d644645fa7dfba53ac.png";